<template>
    <div class="rating tw-flex tw-justify-between"  :style="inputStyles">
        <label :for="`${(config.slug) ? config.slug + '-' : ''}rating-${option}`" v-for="option in options" :key="option"
                class="option tw-text-center"
                :class="{ 'selected': selected == option, 'active': selected >= option }"
                @click="select(option)"
        >
            <input type="radio"
                   :id="`${config.slug}-rating-${option}`"
                   :required="config.required"
                   :value="option"
                   v-model="selected"
                   class="tw-hidden">
            <svg :width="config.max_value > 7 ? 42:64" :height="config.max_value > 7 ? 42:64" viewBox="0 0 512 512" class="star">
                <path d="M480,208H308L256,48,204,208H32l140,96L118,464,256,364,394,464,340,304Z" 
                      :style="{
                        fill: (selected >= option) ? inputStyles.color : 'none',
                        stroke: inputStyles.color,
                        strokeLinejoin: 'round',
                        strokeWidth: '25px'
                    }"
                />
            </svg>
            <span :style="inputStyles">{{ option }}</span>
        </label>
    </div>
</template>

<script>
export default {
    name: 'QuestionOpinionScale',
    props: {
        value: {
            type: Number,
            default: undefined
        },
        inputStyles: {
            type: Object,
        },
        readonly: {
            type: Boolean,
            default: false
        },
        config: {
            type: Object,
            required: true
        },
    },
    data() {
        return {
            selected: null
        };
    },
    computed: {
        options() {
            return [...Array(parseInt(this.config.max_value ?? 5)).keys()].map(i => i + 1);
        },
    },
    mounted() {
        if (this.value) this.selected = this.value;
    },
    watch: {
        value: {
            handler(value) {
                this.selected = this.value;
                this.answer(value);
            },
            immediate: true
        },
    },
    methods: {
        select(option) {
            this.selected = option;
            this.answer(option);
        },
        answer(value) {
            this.$emit('answer', {
                value: value,
                valid: true,
            });
        }
    },
}
</script>
